import styled from 'styled-components';

export const MarkAllButton = styled.button`
  &&& {
    background-color: ${({ theme }) => theme.$primary_light};
    border: 1px solid ${({ theme }) => theme.$primary_medium};
    color: ${({ theme }) => theme.$primary};

    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      background-color: ${({ theme }) => theme.$primary_medium};
      border-color: ${({ theme }) => theme.$primary_medium};
      color: ${({ theme }) => theme.$primary};
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .material-icons {
      color: ${({ theme }) => theme.$primary};
    }

    .mark-all-badge {
      background-color: ${({ theme }) => theme.$primary};
      color: ${({ theme }) => theme.$white};
      font-weight: 600;
    }
  }
`;
